import { render, staticRenderFns } from "./PluginEditPanel.vue?vue&type=template&id=d6111d86&scoped=true"
import script from "./PluginEditPanel.vue?vue&type=script&lang=ts"
export * from "./PluginEditPanel.vue?vue&type=script&lang=ts"
import style0 from "./PluginEditPanel.vue?vue&type=style&index=0&id=d6111d86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6111d86",
  null
  
)

export default component.exports